<template>
  <div class="content-body">
    <div class="xinxi">
      <div class="title">
        基础信息
      </div>
      <div class="line-list">
        <div class="left-title">账户名称：{{ user_info.user_name }}</div>
        <div class="right-title"></div>
      </div>
      <div class="line-list">
        <div class="left-title">公司名称：{{ user_info.company_name }}</div>
        <div class="right-title"></div>
      </div>
      <div class="line-list">
        <div class="left-title">网址名称：{{ user_info.company_name }}</div>
        <div class="right-title"></div>
      </div>
      <div class="line-list">
        <div class="left-title">网址：{{ user_info.company_link }}</div>
        <div class="right-title"></div>
      </div>
      <div class="line-list">
        <div class="right-title">营业执照号：{{ user_info.company_business_no }}</div>
        <div class="right-title"></div>
      </div>
    </div>
    <div class="xinxi">
      <div class="title">
        联系信息
      </div>
      <div class="line-list">
        <div class="left-title">联系人：{{ user_info.contact_name }}</div>
        <div class="right-title">联系地址：{{ user_info.address }}</div>
      </div>
      <div class="line-list">
        <div class="right-title">手机号：{{ user_info.contact_mobile }}</div>
        <div class="right-title">邮箱：{{ user_info.company_mail }}</div>
      </div>
      <div class="line-list">
        <div class="right-title">座机：{{ user_info.company_phone }}</div>
      </div>
    </div>
    <div class="xinxi">
      <div class="title">
        账户资质
      </div>
      <div class="img-lists">
        <div v-for="(item, index) in user_info.company_business" :key="index">
          <img :src="getImg(item.url)" alt="jpg" style="width: 250px; object-fit: contain;">
          <p v-text="title[index]"></p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      user_info: [],
      title: ['营业执照', 'icp备案', '公司资质']
    };
  },
  mounted() {
    this.user_info = JSON.parse(sessionStorage.getItem('user_info'));
    setTimeout(() => {
      this.$function.hiddenLoading();
    }, 200);
  },
  methods: {
    getImg(img) {
      return this.$Config.apiUrl + img;
    }
  }
};
</script>
<style lang="less" scoped>
  .xinxi {
    width: calc(100% - 50px);
    background: #fff;
    padding: 25px;
    .title {
      display: flex;
      align-items: center;
      font-size: 18px;
      color: #221815;
      padding: 10px 0;
      font-weight: 700;
      img {
        width: 18px;
        height: 18px;
        margin-right: 10px;
      }
    }
    .line-list {
      width: 100%;
      display: flex;
      margin-top: 18px;
      .left-title, .right-title {
        width: 350px;
        font-size: 14px;
        color: #221815;
      }
    }
    .img-lists {
      // display: flex;
      div {
        display: inline-block;
        padding-bottom: 30px;
        margin-top: 10px;
        position: relative;
        p {
          width: calc(100% - 15px);
          height: 30px;
          line-height: 30px;
          position: absolute;
          background: rgba(0, 0, 0, .5);
          color: #fff;
          bottom: 32px;
          text-align: center;
        }
      }
      img {
        width: 250px;
        margin-right: 15px;
      }
    }
  }
</style>
